import { NormalizedRegistrationCategory } from '../../set-category/queries';
import { CollapseCard } from '~/components/CollapseCard/CollapseCard';
import { Table } from '~/components/Table/Table';

interface Props {
  category: NormalizedRegistrationCategory;
  disabled: boolean;
}

interface RowProps {
  weight: NormalizedRegistrationCategory['weight_classes'][0];
  category: NormalizedRegistrationCategory;
}

function Row({ weight }: RowProps) {
  return (
    <Table.Row narrow>
      <Table.Col style={{ width: '50%', verticalAlign: 'top' }}>{`${weight.name} kg`}</Table.Col>
      <Table.Col style={{ width: '50%' }}>{weight.limit}</Table.Col>
    </Table.Row>
  );
}

export function QualificationDisplayCard({ category, disabled }: Props) {
  const baseId = `${category.competition_type.id}_${category.age_category.id}`;

  const period =
    category.start_date && category.end_date ? `/ Kvalperiod ${category.start_date} - ${category.end_date}` : '';

  const noQualification = '- Inga kvalgränser';

  return (
    <CollapseCard
      title={`${category.competition_type.description} / ${category.age_category.label} / ${category.is_male ? 'Herr' : 'Dam'} ${disabled ? noQualification : period}`}
      isOpen={false}
      disabled={disabled}
    >
      <Table bg="even">
        <Table.Head>
          <Table.Row narrow>
            <Table.Col as="th">Vikt</Table.Col>
            <Table.Col as="th">Kvalgräns</Table.Col>
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {category.weight_classes.map(weight => (
            <Row key={`${baseId}_${weight.id}`} category={category} weight={weight} />
          ))}
        </Table.Body>
      </Table>
    </CollapseCard>
  );
}
